module.exports = __webpack_public_path__ + "img/GH-kyujin-top-osusume001.26e22bf9.webp";